// extracted by mini-css-extract-plugin
export default {"content":"_c40d3d4a","topWrapper":"_aa2e687b"};